import axios from "axios";
import translationsStore from "../stores/TranslationsStore";

const config = {
  baseUrl: "https://api.pass.me/v1",
};

export const BASE_URL = config.baseUrl;

export const Axios = axios.create({
  baseURL: config.baseUrl,
});

Axios.interceptors.request.use(
  async (config) => {
    const language: string | null = translationsStore.selectedLanguage;

    if (language) {
      const languages = language.split(",");
      if (config.method !== "OPTIONS") {
        const url = config.url!;
        if (url.indexOf("?") > -1) {
          config.url += `&l=${languages[0]}`;
        } else {
          config.url += `?l=${languages[0]}`;
        }
      }
    }
    return config;
  },
  async (error: any) => {
    return Promise.reject(error);
  }
);
